export default "__VITE_ASSET__6ff57d9a__"